import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "input-group mb-3" }
const _hoisted_2 = ["for"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 1,
  "data-bs-toggle": "tooltip",
  "data-bs-title": "Dit veld is beschikbaar in meerdere talen",
  class: "material-symbols-outlined multilingual-indicator"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "mas" }, "visibility", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "form-help"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dp_field = _resolveComponent("dp-field")!
  const _component_dp_error_message = _resolveComponent("dp-error-message")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "before"),
      _createElementVNode("div", {
        class: _normalizeClass(["dp-input", {
            'clearable': _ctx.canClear,
            'can-be-cleared': _ctx.canClear && _ctx.modelValue,
            'form-floating': _ctx.isFloating,
            'has-error': _ctx.errors[_ctx.name],
          }])
      }, [
        _createVNode(_component_dp_field, {
          label: _ctx.label,
          name: _ctx.name,
          rules: _ctx.getRulesAsString(),
          type: _ctx.inputType,
          class: _normalizeClass(["form-control", _ctx.fieldClasses]),
          id: _ctx.name,
          modelValue: _ctx.modelValue,
          placeholder: _ctx.getPlaceholder(),
          disabled: _ctx.disabled,
          step: _ctx.determineStep(),
          onBlur: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('blur'))),
          "onUpdate:modelValue": _ctx.updateValue
        }, null, 8, ["label", "name", "rules", "type", "class", "id", "modelValue", "placeholder", "disabled", "step", "onUpdate:modelValue"]),
        _createElementVNode("label", {
          for: _ctx.name,
          class: "form-label"
        }, [
          _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
          (_ctx.$can('use-feature', 'MULTILINGUAL') && _ctx.isMultilingual)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "(" + _toDisplayString(_ctx.language.toUpperCase()) + ") ", 1))
            : _createCommentVNode("", true),
          (_ctx.checkRequired(_ctx.rules))
            ? (_openBlock(), _createElementBlock("strong", _hoisted_4, "*"))
            : _createCommentVNode("", true)
        ], 8, _hoisted_2),
        (_ctx.canClear && _ctx.modelValue)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clearValue && _ctx.clearValue(...args)), ["prevent"])),
              class: "btn-close",
              type: "reset"
            }))
          : _createCommentVNode("", true),
        (_ctx.isMultilingual)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, "language"))
          : _createCommentVNode("", true)
      ], 2),
      _renderSlot(_ctx.$slots, "afterInput"),
      (_ctx.isInputType('password') && _ctx.withPasswordPreview)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn btn-outline-primary",
            type: "button",
            onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.togglePasswordPreview && _ctx.togglePasswordPreview(...args)), ["stop","prevent"]))
          }, _hoisted_7))
        : _createCommentVNode("", true),
      _createVNode(_component_dp_error_message, {
        class: "invalid-feedback d-block",
        name: _ctx.name
      }, null, 8, ["name"]),
      (_ctx.help)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.help), 1))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "after")
    ])
  ]))
}